// import fetchWrapper from '../../../../apsisEngine/helpers/fetchWrapper';
import fetchWrapper from "../helpers/fetchWrapper";
// import { swalError } from '../../../app/helpers/swal';
import { swalError } from "../../app/helpers/swal";
import { SearchOutlined } from "@ant-design/icons";
import { Input, Modal, Skeleton, Tag, Typography } from "antd";
import { useHistory } from "react-router-dom";
import React from "react";
import { useEffect, useState } from "react";
import { GridDndComponent } from "./DndComponents";
import TopHeader from "./TopHeader";
import Widgets from "./Widgets";
import { WidgetsSettings } from "./Widgets/WidgetsSettings";
import { DashboardWrapper } from "./styles";

const DashboardUnit = ({
  data,
  customiseWidgets,
  setCustomiseWidgets,
  submitWidgetData,
  setWidgetsData,
  widgetsData,
  userDashboardData,
  moduleInfo,
  initialLoading
}) => {
  const [loadings, setLoadings] = useState([]);
  const [open, setOpen] = useState(false);
  const [actionCard, setActionCard] = useState({
    isActionCard: false,
    cardActionData: {},
  });
  const [activeKey, setActiveKey] = useState("1");
  const [activeFilter, setActiveFilter] = useState(false);

  const [addWidgetdata, setAddWigetData] = useState({});
  const [widgetCustomizeOpt, setWidgetCustomizeOpt] = useState(false);
  const [mainWidgetData, setMainWidgetData] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const { Title } = Typography;
  const history = useHistory();
  const enterLoading = (index) => {
    setLoadings((prevLoadings) => {
      const newLoadings = [...prevLoadings];
      newLoadings[index] = true;
      return newLoadings;
    });
  };
  const turnOffLoading = (index) => {
    setLoadings((prevLoadings) => {
      const newLoadings = [...prevLoadings];
      newLoadings[index] = false;
      return newLoadings;
    });
  };

  const handleCustomiseWidgets = () => {
    setCustomiseWidgets(true);
    setWidgetCustomizeOpt(true);
  };

  const handleSaveLayout = () => {
    enterLoading(0);
    submitWidgetData();
    turnOffLoading(0);
  };

  const handleCancel = () => {
    setCustomiseWidgets(false);
    history.push({
      pathname: `/`,
    });
  };

  const handleLayout = (currentLayoutData) => {
    let idx = 0;
    for (let el of widgetsData) {
      if (el?.dnd_layout_config) {
        const layoutConfigData = JSON.parse(el?.dnd_layout_config);
        for (let index = 0; index < currentLayoutData?.length; index++) {
          if (layoutConfigData[0].i == currentLayoutData[index].i) {
            const convertConfigFile = JSON.stringify([
              currentLayoutData[index],
            ]);
            const newWidgetsData = [...widgetsData];
            newWidgetsData[idx].dnd_layout_config = convertConfigFile;
            setWidgetsData(newWidgetsData);
          }
        }
        idx++;
      }
    }
    // widgetsData?.map((el, idx) => {
    //   if (el?.dnd_layout_config) {
    //     const layoutConfigData = JSON.parse(el?.dnd_layout_config);
    //     for (let index = 0; index < currentLayoutData?.length; index++) {
    //       if (layoutConfigData[0].i == currentLayoutData[index].i) {
    //         const convertConfigFile = JSON.stringify([
    //           currentLayoutData[index],
    //         ]);
    //         const newWidgetsData = [...widgetsData];
    //         newWidgetsData[idx].dnd_layout_config = convertConfigFile;
    //         setWidgetsData(newWidgetsData);
    //       }
    //     }
    //   }
    // });
  };

  const handleChecked = (e, widget_id) => {
    const currentValue = data?.find((el) => {
      if (el.dashboard_widget_id === widget_id) {
        return el;
      } else return null;
    });
    e.stopPropagation();
    if (e.target.checked) {
      setWidgetsData((data) => [
        ...data,
        {
          dashboard_widget_id: widget_id,
          dnd_layout_config: currentValue?.dnd_layout_config,
        },
      ]);
    } else {
      const filteredData = widgetsData.filter((el) => {
        if (el.dashboard_widget_id !== widget_id) {
          return el;
        }
      });
      setWidgetsData(filteredData);
    }
  };

  const requestSearch = (searchedVal) => {
    if (!addWidgetdata.widgetData) return;

    if (searchedVal.length < 1) {
      setFilterData([]);
      setActiveFilter(false);
      return;
    }

    const filteredRows = addWidgetdata.widgetData.filter((row) =>
      row.title
        .toString()
        .toLowerCase()
        .includes(searchedVal.toLowerCase())
    );

    setFilterData(filteredRows);
    setActiveFilter(true);
  };

  const filterTabData = (activeKey) => {
    const newWidgetsData = [...addWidgetdata.widgetData].filter(
      (item) => item.module_id === parseInt(activeKey)
    );
    if (newWidgetsData?.length > 0) {
      setMainWidgetData(newWidgetsData);
    } else {
      setMainWidgetData(addWidgetdata.widgetData);
    }
  };
  const getWidgets = async () => {
    await fetchWrapper
      .get(`/dashboard/widget/list/22`)
      .then((response) => {
        if (!response?.error) {
          const data = response.data;
          setAddWigetData(data);
        } else {
          swalError(response?.error?.message);
        }
      })
      .catch((error) => {
        swalError(error?.message);
      });
  };
  useEffect(() => {
    addWidgetdata.widgetData && filterTabData(activeKey);
  }, [addWidgetdata.widgetData]);

  useEffect(() => {
    if (open) {
      getWidgets();
    }
  }, [open]);
  return (
    <DashboardWrapper>
      <div className="text-right px-2">
        <TopHeader
          setOpen={setOpen}
          handleCustomiseWidgets={handleCustomiseWidgets}
          customiseWidgets={customiseWidgets}
          handleSaveLayout={handleSaveLayout}
          loading={loadings[0]}
          handleCancel={handleCancel}
          data={data}
        />
      </div>

      {data?.length > 0 ? (
        <>
          <div className="mb-4">
            <GridDndComponent
              data={data}
              handleLayout={handleLayout}
              handleChecked={handleChecked}
              customiseWidgets={customiseWidgets}
              userDashboardData={userDashboardData}
              moduleInfo={moduleInfo}
              widgetCustomizeOpt={widgetCustomizeOpt}
            />
          </div>
        </>
      ) : (
        <>
         {(initialLoading )?<div>
          <Skeleton />
          <Skeleton/>
          <Skeleton/>
         </div>:<h5 className="text-center text-secondary">Please configure your preferred widget.</h5>}
        </>
      )}
      <Modal
        className="custom-modal-header"
        title={
          <div className="d-flex align-items-baseline">
            {!actionCard.isActionCard ? (
              <>
                <h3 style={{ fontSize: "18px", fontWeight: "bold" }}>
                  Add widget
                </h3>
                <Input
                  type="text"
                  className="w-50 ml-5 custom-modal-search"
                  placeholder="Filter..."
                  prefix={<SearchOutlined />}
                  onChange={(e) => requestSearch(e.target.value)}
                />
              </>
            ) : (
              <>
                <Tag color="green">
                  <Title level={5}>{actionCard.cardActionData.title}</Title>
                </Tag>
              </>
            )}
          </div>
        }
        centered
        open={open}
        onOk={() => setOpen(false)}
        onCancel={() => setOpen(false)}
        width={850}
        footer={null}
      >
        {!actionCard.isActionCard ? (
          <Widgets
            setActionCard={setActionCard}
            setActiveKey={setActiveKey}
            activeKey={activeKey}
            myArray={activeFilter ? filterData : mainWidgetData}
            activeFilter={activeFilter}
            data={addWidgetdata}
            filterTabData={filterTabData}
          />
        ) : (
          <WidgetsSettings
            filterData={actionCard.cardActionData}
            slug={actionCard.cardActionData.search_panel_slug}
            setOpen={setOpen}
            moduleInfo={moduleInfo}
            setActionCard={setActionCard}
            setActiveFilter={setActiveFilter}
            data={data}
          />
        )}
      </Modal>
    </DashboardWrapper>
  );
};
export default DashboardUnit;
